import {
	Building2,
	CalendarRange,
	// ClipboardList, // OK-71: hidden until Requisições ships
	Clock,
	FileSpreadsheet,
	FileText,
	FolderOpen,
	LayoutDashboard,
	ListTodo,
	type LucideIcon,
	NotebookPen,
	// Package, // OK-71: hidden until Almoxarifado ships
	Settings2,
	Users,
	// Wallet, // OK-71: hidden until Financeiro ships
} from "lucide-react";
import type { PermissionInput } from "@/hooks/use-permissions.ts";

export type NavBadge = "pending-attendance";

export interface NavItem {
	title: string;
	segment: string;
	icon: LucideIcon;
	permission?: PermissionInput;
	badge?: NavBadge;
}

export interface NavGroup {
	title: string;
	icon: LucideIcon;
	items: NavItem[];
}

export const navItems: NavItem[] = [
	{ title: "Dashboard", segment: "", icon: LayoutDashboard },
	{ title: "Diário de Obra", segment: "feed", icon: NotebookPen },
	{
		title: "Presença",
		segment: "presenca",
		icon: Clock,
		permission: ["time_entries:clock", "time_entries:list"],
	},
	{
		title: "Equipe",
		segment: "equipe",
		icon: Users,
		badge: "pending-attendance",
	},
	{
		title: "Folha de horas",
		segment: "folha-de-horas",
		icon: FileSpreadsheet,
		permission: "time_entries:list_team",
	},
	// OK-71: hidden from the sidebar until these features ship post go-live.
	// { title: "Almoxarifado", segment: "almoxarifado", icon: Package },
	// { title: "Requisições", segment: "requisicoes", icon: ClipboardList },
	// { title: "Financeiro", segment: "financeiro", icon: Wallet },
];

export const obraGroup: NavGroup = {
	title: "Obra",
	icon: Building2,
	items: [
		{ title: "Etapas", segment: "etapas", icon: ListTodo },
		{
			title: "Cronograma",
			segment: "cronograma",
			icon: CalendarRange,
			permission: "construction_stage_schedules:view",
		},
		{
			title: "Relatório de Obra",
			segment: "rdo",
			icon: FileText,
			permission: "rdos:list",
		},
		{
			title: "Documentos",
			segment: "documentos",
			icon: FolderOpen,
			permission: "documents:list",
		},
		{
			title: "Configurações da obra",
			segment: "configuracoes-da-obra",
			icon: Settings2,
		},
	],
};

export function navItemPath(obraKey: string, segment: string) {
	return segment ? `/${obraKey}/${segment}` : `/${obraKey}`;
}

export function isNavItemActive(segment: string, subPath: string) {
	return segment === "" ? subPath === "" : subPath.startsWith(segment);
}
